import React from 'react'
import { useIntl } from 'react-intl'
import { Select } from 'mailup-web-components'
import PropTypes from 'prop-types'

const ThemeSelect = ({ value, onChange, disabled }) => {
  const intl = useIntl()

  const options = [
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeCircleColor'
      }),
      value: 'circle-color'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeCircleBlue'
      }),
      value: 'circle-blue'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeCircleGray'
      }),
      value: 'circle-gray'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeTCircleDefaultGray'
      }),
      value: 't-circle-default-gray'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeCircleDarkGray'
      }),
      value: 'circle-dark-gray'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeTCircleColor'
      }),
      value: 't-circle-color'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeTCircleWhite'
      }),
      value: 't-circle-white'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeColored'
      }),
      value: 'colored'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeBlue'
      }),
      value: 'blue'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeDefaultGray'
      }),
      value: 'default-gray'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeDarkGray'
      }),
      value: 'dark-gray'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeTOnlyLogoColor'
      }),
      value: 't-only-logo-color'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeTOnlyLogoDarkGray'
      }),
      value: 't-only-logo-dark-gray'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeTOnlyLogoDefaultGray'
      }),
      value: 't-only-logo-default-gray'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeTOnlyLogoWhite'
      }),
      value: 't-only-logo-white'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeTOutlineCircleColor'
      }),
      value: 't-outline-circle-color'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeTOutlineCircleDarkGray'
      }),
      value: 't-outline-circle-dark-gray'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeTOutlineCircleDefaultGray'
      }),
      value: 't-outline-circle-default-gray'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeTOutlineCircleWhite'
      }),
      value: 't-outline-circle-white'
    }
  ]
  const optionGroups = {
    group1: {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeCircle'
      }),
      values: [
        'circle-color',
        'circle-blue',
        'circle-gray',
        't-circle-default-gray',
        'circle-dark-gray',
        't-circle-color',
        't-circle-white',
        't-only-logo-dark-gray'
      ]
    },

    group2: {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsRounded'
      }),
      values: ['colored', 'blue', 'default-gray', 'dark-gray']
    },
    group3: {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeLogoOnly'
      }),
      values: [
        't-only-logo-color',
        't-only-logo-dark-gray',
        't-only-logo-default-gray',
        't-only-logo-white'
      ]
    },
    group4: {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.SocialIconsThemeOutlined'
      }),
      values: [
        't-outline-circle-color',
        't-outline-circle-dark-gray',
        't-outline-circle-default-gray',
        't-outline-circle-white'
      ]
    }
  }
  return (
    <Select
      options={options}
      optionGroups={optionGroups}
      value={value}
      onChange={onChange}
      searchable={false}
      disabled={disabled}
    />
  )
}

export default ThemeSelect

ThemeSelect.propTypes = {
  value: PropTypes.num,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
}
